export default function(array) {
  return (array[array.length-1] - array[0]) || 0;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-parser/src/parsers/expression/span.js
// module id = 948
// module chunks = 0